import { render, staticRenderFns } from "./DialogAddUser.vue?vue&type=template&id=72173759&scoped=true&"
import script from "./DialogAddUser.vue?vue&type=script&lang=js&"
export * from "./DialogAddUser.vue?vue&type=script&lang=js&"
import style0 from "./DialogAddUser.vue?vue&type=style&index=0&id=72173759&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72173759",
  null
  
)

export default component.exports